var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from "react";
import { Provider } from "react-redux";
import OrdersTable from "../Components/OrdersTables";
import store from "@redux/store";
import { ProductOrderContext } from "@frameworks/salesjourney/components/Features/ActivityBook/RM_Orderbook/ProductOrders/ProductOrdersContext";
import { EProductIds, ESubProductIds, } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
var Orderbook = function (props) {
    return (React.createElement(Provider, { store: store },
        React.createElement(OrdersTable, __assign({}, props))));
};
var getProductNames = function (categoryId) {
    switch (categoryId) {
        case ESubProductIds.StructuredProducts:
            return "Structured Products (SP)";
        case ESubProductIds.NCD:
            return "NCD";
        case ESubProductIds.Bonds:
            return "Bonds";
        case ESubProductIds.UnlistedShares:
            return "Unlisted Shares";
        default:
            return "Unknown Product";
    }
};
var OtcProductOrder = function (_a) {
    var subCategoryId = _a.subCategoryId, parentId = _a.parentId, isMultiple = _a.isMultiple;
    var productOrdersContext = useContext(ProductOrderContext);
    return (React.createElement(React.Fragment, null,
        React.createElement(Orderbook, { subCategoryId: subCategoryId, viewAllButtonCallback: function () {
                productOrdersContext.viewAllClickCallback(parentId ? parentId : EProductIds.MANAGED_PORTFOLIO, String(subCategoryId));
            }, setToastDetails: productOrdersContext.setToastDetails, isShowViewAll: !productOrdersContext.detailedViewEnabled, title: getProductNames(String(subCategoryId)), showFiltersComponent: productOrdersContext.detailedViewEnabled, errorScreenMessage: "You don't seem to have any transactions as of now in ".concat(getProductNames(String(subCategoryId)), "."), isMultiple: isMultiple })));
};
export default OtcProductOrder;
